import { useToggle } from 'ahooks';
import { useEffect } from 'react';

import { ConfirmModal } from '@/components/ConfirmModal';
import { PageLevel } from '@/components/PageContainer';
import PageHeader from '@/components/PageContainer/PageHeader';
import { useI18nContext } from '@/i18n/I18n';

import { useUserInfo } from '../../hooks/useUserInfo';

interface IApiBreadCrumb {
  isEdit?: boolean;
}
export const CreateApiBreadCrumb = (props: IApiBreadCrumb) => {
  const { isEdit } = props;
  const breadcrumbName = !isEdit ? 'Create New Key' : 'editApi';
  const [$t] = useI18nContext();
  const [showBackTip, { toggle }] = useToggle(false);
  const {
    loading,
    hasGoogle2fa,
    isSubAccountLogin,
    backApiManagement,
    isDemoAccount,
  } = useUserInfo(isEdit);

  useEffect(() => {
    if (
      ((!hasGoogle2fa && !loading) || (isSubAccountLogin && isEdit)) &&
      !isDemoAccount
    ) {
      backApiManagement();
    }
  }, [
    loading,
    isSubAccountLogin,
    isEdit,
    hasGoogle2fa,
    backApiManagement,
    isDemoAccount,
  ]);
  return (
    <>
      <PageHeader
        pageLevel={PageLevel.sub}
        breadItems={[
          {
            key: 'API Management',
            label: () => {
              return <a onClick={toggle}>{$t('API Management')}</a>;
            },
          },
          {
            key: breadcrumbName,
            title: $t(breadcrumbName),
          },
        ]}
      />
      <ConfirmModal
        isVisible={showBackTip}
        showCancelBtn
        content={
          <div style={{ textAlign: 'center' }}>
            <i
              className="byIcon icon-gantanhao"
              style={{ fontSize: 64, color: '#F7A600' }}
            ></i>
            <div
              className="font-size-card-title"
              style={{ marginBottom: 24, fontWeight: 600 }}
            >
              {$t('settingBackP1')}
            </div>
          </div>
        }
        cancelBtnText={$t('settingBackP3')}
        okBtnText={$t('settingBackP2')}
        onCancel={toggle}
        onConfirm={backApiManagement}
      />
    </>
  );
};
